(() => {
 function setupCarousels(){
  document.querySelectorAll('[data-kd-ed-carousel]').forEach(carousel=>{
   if(carousel.dataset.ready)return;
   carousel.dataset.ready='true';
   const slides=[...carousel.querySelectorAll('[data-kd-ed-slide]')];let current=0;
   function show(index){current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.hidden=i!==current;slide.classList.toggle('is-active',i===current);});carousel.querySelector('[data-kd-ed-current]').textContent=String(current+1);}
   carousel.querySelector('[data-kd-ed-prev]')?.addEventListener('click',()=>show(current-1));
   carousel.querySelector('[data-kd-ed-next]')?.addEventListener('click',()=>show(current+1));
  });
 }
 document.addEventListener('click',event=>{
  const menu=document.querySelector('[data-kd-ed-menu]');
  if(event.target.closest('[data-kd-ed-menu-open]'))menu?.showModal();
  if(event.target.closest('[data-kd-ed-menu-close], [data-kd-ed-menu] a')||event.target===menu)menu?.close();
  if(event.target.closest('[data-kd-ed-top]')){const scroller=document.querySelector('.page-wrapper');const behavior=matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth';scroller?.scrollTo({top:0,behavior});window.scrollTo({top:0,behavior});}
 });
 document.addEventListener('shopify:section:load',setupCarousels);
 setupCarousels();
})();
